import { useCallback, useEffect, useMemo, useState } from "react";

import { obterAnonId } from "./anonId";
import { buscarOfertas } from "./api";

// Estado da Campanha Inteligente pra quem está olhando o cardápio.
// Refaz a busca quando o login muda, quando o cadastro ganha CPF/e-mail/
// nascimento (bloqueado → ativo) e quando o dia da oferta vira.
export function useOfertasDoDia({ habilitado, cliente, modulo = "Cardapio" }) {
  const clienteId = cliente?.id || null;
  const assinatura = cliente
    ? [cliente.id, cliente.cpf, cliente.email, cliente.data_nascimento].map((v) => v || "").join("|")
    : "";
  const [dados, setDados] = useState({ estado: "carregando" });

  const carregar = useCallback(async () => {
    if (!habilitado) {
      setDados({ estado: "desligada" });
      return;
    }
    try {
      const data = await buscarOfertas({ clienteId, anonId: clienteId ? null : obterAnonId(), modulo });
      // `paraCliente` diz de quem são estas ofertas: troca de cliente no PDV não
      // pode aplicar, nem por um instante, as ofertas do cliente anterior.
      setDados({ ...(data && data.estado ? data : { estado: "desligada" }), paraCliente: clienteId });
    } catch {
      // Falha de rede não pode apagar ofertas do carrinho: "erro" ≠ "desligada".
      setDados({ estado: "erro" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [habilitado, clienteId, assinatura, modulo]);

  useEffect(() => { carregar(); }, [carregar]);

  useEffect(() => {
    if (!dados.expira_em) return undefined;
    const expira = Date.parse(dados.expira_em);
    const aoVoltar = () => {
      if (document.visibilityState === "visible" && Date.now() > expira) carregar();
    };
    document.addEventListener("visibilitychange", aoVoltar);
    const falta = expira - Date.now();
    const timer = falta > 0 && falta < 6 * 60 * 60 * 1000 ? setTimeout(carregar, falta + 2000) : null;
    return () => {
      document.removeEventListener("visibilitychange", aoVoltar);
      if (timer) clearTimeout(timer);
    };
  }, [dados.expira_em, carregar]);

  return useMemo(() => {
    const porChave = new Map();
    const porProduto = new Map();
    for (const o of dados.ofertas || []) {
      porChave.set(o.chave, o);
      const id = String(o.product_id);
      porProduto.set(id, [...(porProduto.get(id) || []), o]);
    }
    return {
      ...dados,
      porChave,
      porProduto,
      marcados: new Set((dados.marcados || []).map(String)),
      recarregar: carregar,
    };
  }, [dados, carregar]);
}
